import { FETCH_ROAMING_PARTNER_LIST} from "../actionTypes";
import { fetchRoamingPartnersList } from "../../../api/newService/roamingPartners.service";

const request = () => ({ type: FETCH_ROAMING_PARTNER_LIST.REQUEST });
const failure = (error) => ({ type: FETCH_ROAMING_PARTNER_LIST.FAILURE,error });
const success = (data) => ({ type: FETCH_ROAMING_PARTNER_LIST.SUCCESS,data});

export const getRoamingPartnerList = () => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchRoamingPartnersList()
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
